import styled from "styled-components";
import variables from "../style/variables";

const { screen_lg, screen_md, screen_sm } = variables;

export const TopMenu = styled.div`
	height: 100px;
	background-color: #ffffff;
	padding-top: 20px;
	width: 100%;
	box-shadow: rgba(54, 69, 73, 0.14) 0px 1px 5px 0px;
	z-index: 9;

	.nav-logo {
		position: relative;
		min-height: 1px;
		padding-right: 15px;
		padding-left: 15px;
		float: left;
		height: 55px;
		width: 30%;

		img {
			max-width: 285px;
			width: 100%;
			position: relative;
			top: 50%;
			-moz-transform: translateY(-50%);
			-o-transform: translateY(-50%);
			-ms-transform: translateY(-50%);
			-webkit-transform: translateY(-50%);
			transform: translateY(-50%);
		}
	}
	.nav-menu {
		float: left;
		height: 55px;
		margin-top: 5px;
		width: 70%;

		ul {
			float: right;
			list-style: none;

			li a,
			li button {
				font-size: 16px;
				font-weight: 400;
				font-style: normal;
				font-stretch: normal;
				line-height: 1.69;
				letter-spacing: normal;
				color: #3d3f43;
				padding: 10px 15px;
			}

			li.active {
				a {
					color: #ffffff;
				}
			}

			.red-gg {
				color: #ea4335 !important;
			}
			.red-gg-li {
				a {
					color: #ea4335 !important;
				}
				&.active {
					a {
						color: #ffffff !important;
					}
				}
			}
		}
	}

	${(props) =>
		props.fixedHead &&
		`
        position: fixed;
        top: 0;
    `}

	${(props) =>
		props.hideXS &&
		`
        @media(max-width: ${screen_sm}) {
            display: none;
        }
    `}

    @media(max-width: ${screen_lg}) {
		.nav-logo {
			width: 30%;
		}
		.nav-menu {
			width: 70%;
		}
	}

	@media (max-width: ${screen_md}) {
		// height: 150px;
	}
`;



// WEBPACK FOOTER //
// ./src/components/style/topmenu.jsx